import React, { useState } from 'react';
import Dialog from '#lib/components/dialog.jsx';
import Button from '#lib/components/button.jsx';
import Input from '#lib/components/input.jsx';
import { addClasses } from '#lib/helpers/class.js';

export function NewPlaceModal(props) {
    const { isOpen, onClose, onSubmit } = props;

    const [inputValue, setInputValue] = useState('');
    const [invalid, setInvalid] = useState(false);

    const onClick = () => {
        if (inputValue === '') {
            setInvalid(true);
            return;
        }
        onSubmit(inputValue);
        setInputValue(() => '');
        onClose();
    };

    return (
        <Dialog isOpen={isOpen} onClose={onClose}>
            <Dialog.Panel className="flex flex-col space-y-6 w-1/2 lg:w-1/3 max-h-[75%] overflow-auto">
                <div className="pr-4 pb-2">
                    <Dialog.CloseButton />
                    <b>{_t.edit.places.newPlaceText()}</b>
                </div>
                <div className="flex justify-end gap-x-4">
                    <Input.Full
                        placeholder={'Location'}
                        onChange={(e) => {
                            setInputValue(e.target.value);
                            e.target.value && setInvalid(false);
                        }}
                        hasError={invalid}
                        className={'w-full'}
                        inputClassName={addClasses('h-[35px]')}
                    />
                    <Button
                        onClick={onClick}
                        look="primary"
                        className={addClasses('flex items-center justify-center h-[35px]')}
                        size="md"
                    >
                        <span>{_t.edit.places.addPlace()}</span>
                    </Button>
                </div>
            </Dialog.Panel>
        </Dialog>
    );
}
